import { render, staticRenderFns } from "./DocumentSummary.vue?vue&type=template&id=523b7376&scoped=true&"
import script from "./DocumentSummary.vue?vue&type=script&lang=js&"
export * from "./DocumentSummary.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSummary.vue?vue&type=style&index=0&id=523b7376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b7376",
  null
  
)

export default component.exports